import { IntegrationPartner } from '@centric-os/types';

const ThriveBoostIntegrationTypes = [
  IntegrationPartner.BOOST.toLowerCase(),
  IntegrationPartner.THRIVE.toLowerCase(),
];

/**
 * Returns true when integrationType maps to thrive/boost.
 */
export const isThriveOrBoostIntegrationType = (integrationType?: string | null): boolean => {
  const type = String(integrationType ?? '').toLowerCase();
  return ThriveBoostIntegrationTypes.includes(type);
};

/**
 * Normalizes an IntegrationPartner enum value to the snake_case key used under
 * `meta.software_integrations` (and related route params).
 * Newer enum values are already lowercase; older Title Case values need this transform.
 */
export const toSoftwareIntegrationKey = (integrationType: IntegrationPartner): string =>
  integrationType.toLowerCase().replaceAll(' ', '_');
